<main class="c-main" role="main">
    <div class="c-page-other2bulk">
        <div class="container u-pb60">
            <div class="row mobile--orange u-pt30">
                <div class="col-md-8">
                    <!-- <nav aria-label="breadcrumb">
              <ol class="breadcrumb">
                <li class="breadcrumb-item"><a class="js-txt1" >Home</a></li>
                <li class="breadcrumb-item active" aria-current="page">-   </li><span class="js-txt2"> Visitor</span>
              </ol>
            </nav> -->
                    <h2 class="o-title js-txt3">{{'LeaderGroupPortal.title'| translate}}</h2>
                    <p class="o-text js-txt4">{{'LeaderGroupPortal.subtitle'| translate}}.</p>
                </div>
            </div>

            <div class="row" style="padding: 30px;" *ngIf="!accessPage">
                <div class="col-md-12">
                    <p>{{'LeaderGroupPortal.completeCaptcha'| translate}}</p>
                </div>
                <div class="col-md-12">
                    <div class="card mt-3" align="center">
                        <div class="card-body">
                            <re-captcha (resolved)="resolved($event)" [siteKey]="key"></re-captcha>
                        </div>
                    </div>
                </div>
            </div>
            <div *ngIf="accessPage">

                <div class="row">
                    <div class="col-md-12 u-pt20 u-pb50">
                        <div class="c-card c-card--detail">
                            <h2 class="o-title o-title--medium o-title--orange js-txt5">{{'LeaderGroupPortal.requestDetail'| translate}}</h2>
                            <div class="row u-pt20">

                                <div class="col-md-2"><strong class="js-txt9">{{'LeaderGroupPortal.labelSite'| translate}}:</strong>
                                    <p>{{Request.site}}</p>
                                </div>
                                <div class="col-md-2"><strong class="js-txt10">{{'LeaderGroupPortal.labelZone'| translate}}:</strong>
                                    <p>{{Request.zone}}</p>
                                </div>
                                <div class="col-md-2" *ngIf="!(Request.subZone===undefined || Request.subZone==='0' || Request.subZone==='')"><strong class="js-txt11">{{'LeaderGroupPortal.labelSubzone'| translate}}:</strong>
                                    <p>{{Request.subZone}}</p>
                                </div>
                                <div class="col-md-2"><strong class="js-txt6">{{'LeaderGroupPortal.labelFrom'| translate}}:</strong>
                                    <p>{{Request.from}}</p>
                                </div>
                                <div class="col-md-2"><strong class="js-txt7">{{'LeaderGroupPortal.labelTo'| translate}}:</strong>
                                    <p>{{Request.to}}</p>
                                </div>
                                <div class="col-md-12 u-pt20" *ngIf="!(Request.purpuse===undefined || Request.purpuse===0 || Request.purpuse==='')"><strong class="js-txt12">{{'LeaderGroupPortal.purpuse'| translate}}:</strong>
                                    <p class="js-txt13">{{Request.purpuse}}.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="hr orange"></div>
                <form class="o-form" [formGroup]="leaderForm" (ngSubmit)="onSubmit()">
                    <div class="row u-pt20">
                        <div class="col-md-12 u-pb20">
                            <h2 class="o-title o-title--medium o-title--orange js-txt14">{{'LeaderGroupPortal.LeaderInfo'| translate}}</h2>
                            <p class="o-text js-txt15">{{'LeaderGroupPortal.subtitlePersonalInfo'| translate}}.</p>
                        </div>
                    </div>
                    <div id="LeaderInformation" class="row">
                        <div class="col-md-6">
                            <div class="form-group">
                                <label class="o-title o-title--label o-title--required js-txt27">{{'LeaderGroupPortal.labelName'| translate}}:</label>
                                <input class="o-form__input" type="text" formControlName="firstName">
                                <div *ngIf="leaderForm.controls['firstName'].hasError('required') && submited" style="width:100%; background-color: #F2F0E9" align="center">
                                    <span><h5 style="padding: 15px;"><mat-error style=" white-space: normal; "><i class="icon icon-close"></i> {{'LeaderGroupPortal.requiredInfo'| translate}}</mat-error></h5></span>
                                </div>
                            </div>

                        </div>
                        <div class="col-md-6">
                            <div class="form-group">
                                <label class="o-title o-title--label o-title--required js-txt29">{{'LeaderGroupPortal.labelLastName'| translate}}:</label>
                                <input class="o-form__input" type="text" formControlName="lastName">
                                <div *ngIf="leaderForm.controls['lastName'].hasError('required') && submited" style="width:100%; background-color: #F2F0E9" align="center">
                                    <span><h5 style="padding: 15px;"><mat-error style=" white-space: normal; "><i class="icon icon-close"></i> {{'LeaderGroupPortal.requiredInfo'| translate}}</mat-error></h5></span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-6">
                            <div class="form-group u-pb20">
                                <label class="o-title o-title--label o-title--required js-txt31">{{'LeaderGroupPortal.labelCountry'| translate}}:</label>
                                <label class="o-form__input" style="cursor: no-drop;">  {{leaderForm.controls.country.value}} </label>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="form-group u-pb30">
                                <label class="o-title o-title--label o-title--required js-txt33">{{'LeaderGroupPortal.documentType'| translate}}</label>
                                <label class="o-form__input" style="cursor: no-drop;" *ngIf="leaderForm.controls.documentType.value=='nationalid'">   {{'LeaderGroupPortal.labelRUT'| translate}}   </label>
                                <label class="o-form__input" style="cursor: no-drop;" *ngIf="leaderForm.controls.documentType.value=='passportnumber'">   {{'LeaderGroupPortal.labelPassport'| translate}}   </label>
                            </div>
                        </div>
                    </div>
                    
                    <div class="row">
                        <div class="col-md-6">
                            <div class="form-group">
                                <label class="o-title o-title--label o-title--required js-txt35">{{'LeaderGroupPortal.labelRutpassport'| translate}}:</label>
                                <label class="o-form__input" style="cursor: no-drop;">  {{leaderForm.controls.documentNumber.value}} </label>

                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="form-group">
                                <label class="o-title o-title--label o-title--required js-txt37">{{'LeaderGroupPortal.labelPhone'| translate}}:</label>
                                <input class="o-form__input" type="text" formControlName="phone">
                                <div *ngIf="leaderForm.controls['phone'].hasError('required') && submited" style="width:100%; background-color: #F2F0E9" align="center">
                                    <span><h5 style="padding: 15px;"><mat-error style=" white-space: normal; "><i class="icon icon-close"></i>{{'LeaderGroupPortal.requiredInfo'| translate}}</mat-error></h5></span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class=" orange u-mb20"></div>

                    <div class="col-md-12" style="padding-bottom: 15px;padding-bottom: 15px;padding-right: 0px;padding-left: 0px;">
                        <div class="form-group ">
                            <label class="o-title o-title--label o-title--required">{{'LeaderGroupPortal.selectGender'| translate}}</label>
                        </div>
                        <form class="o-form" [formGroup]="leaderForm">
                            <div class="o-form__tabSH u-mb30" id="radioManualBulk">

                                <input class="form-check-input" type="radio" formControlName="gender" value="Male" id="Male">
                                <label class="transition equalHM" for="Male">
                             <strong >{{'LeaderGroupPortal.optMale'| translate}}</strong>
                            </label>

                                <input class="form-check-input" type="radio" formControlName="gender" value="Female" id="Female">
                                <label class="transition equalHM" for="Female" style="white-space: pre-wrap">
                            <strong >{{'LeaderGroupPortal.optFemale'| translate}}</strong>
                          </label>
                                <input class="form-check-input" type="radio" formControlName="gender" value="Other" id="Other">
                                <label class="transition equalHM" for="Other" style="white-space: pre-wrap">
                           <strong >{{'LeaderGroupPortal.optOther'| translate}}</strong>
                         </label>
                            </div>
                        </form>

                        <div *ngIf="leaderForm.controls['gender'].hasError('required') && submited" style="width:100%; background-color: #F2F0E9" align="center;">
                            <span>
          <h5 style="padding: 15px;">
            <mat-error style=" white-space: normal; ">
              <i class="icon icon-close"></i> {{'LeaderGroupPortal.requiredInfo'| translate}}
            </mat-error>
          </h5>
        </span>
                        </div>

                    </div>

                    <div id="PersonalCompany" class="row">
                        <div class="col-md-6">
                            <div class="form-group">
                                <label class="o-title o-title--label  js-txt16">{{'LeaderGroupPortal.labelCompany'| translate}}:</label>
                                <input class="o-form__input" formControlName="company" type="text">
                                <!-- <div *ngIf="leaderForm.controls['company'].hasError('required') && submited" style="width:100%; background-color: #F2F0E9" align="center">
                                    <span><h5 style="padding: 15px;"><mat-error style=" white-space: normal; "><i class="icon icon-close"></i>{{'publicLeaderGroupForm.requiredInfo'| translate}}</mat-error></h5></span>
                                </div> -->

                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="form-group u-pb20">
                                <label class="o-title o-title--label  js-txt18">{{'LeaderGroupPortal.orgHealthSafe'| translate}}:                             <svg matTooltip="{{'LeaderGroupPortal.tooltipMedicalOrganization' | translate}}​​" width="1em" height="1em" viewBox="0 0 16 16" 
                                    class="bi bi-question-circle ptooltip--static ptooltip" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
        
                                        <path fill-rule="evenodd" d="M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
                    
                                        <path d="M5.255 5.786a.237.237 0 0 0 .241.247h.825c.138 0 .248-.113.266-.25.09-.656.54-1.134 1.342-1.134.686 0 1.314.343 1.314 1.168 0 .635-.374.927-.965 1.371-.673.489-1.206 1.06-1.168 1.987l.003.217a.25.25 0 0 0 .25.246h.811a.25.25 0 0 0 .25-.25v-.105c0-.718.273-.927 1.01-1.486.609-.463 1.244-.977 1.244-2.056 0-1.511-1.276-2.241-2.673-2.241-1.267 0-2.655.59-2.75 2.286zm1.557 5.763c0 .533.425.927 1.01.927.609 0 1.028-.394 1.028-.927 0-.552-.42-.94-1.029-.94-.584 0-1.009.388-1.009.94z"/>
                    
                                      </svg>
                
                </label>
                                <input class="o-form__input" formControlName="safetyOrganization" type="text">
                                <!-- <div *ngIf="leaderForm.controls['safetyOrganization'].hasError('required') && submited" style="width:100%; background-color: #F2F0E9" align="center">
                                    <span><h5 style="padding: 15px;"><mat-error style=" white-space: normal; "><i class="icon icon-close"></i>{{'publicLeaderGroupForm.requiredInfo'| translate}}</mat-error></h5></span>
                                </div> -->
                            </div>
                        </div>
                    </div>
                    <div id="EmergencyInfo" class="row u-pt20">
                        <div class="col-md-12">
                            <h2 class="o-title o-title--medium js-txt21">{{'LeaderGroupPortal.emergencyContact'| translate}}</h2>
                            <p class="o-text js-txt26">{{'LeaderGroupPortal.emergencyInfo'| translate}} </p>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-6">
                            <div class="form-group">
                                <label class="o-title o-title--label o-title--required">{{'LeaderGroupPortal.labelFullName'| translate}}:</label>
                                <input class="o-form__input" type="text" formControlName="emergencyFullName">
                                <div *ngIf="leaderForm.controls['emergencyFullName'].hasError('required') && submited" style="width:100%; background-color: #F2F0E9" align="center">
                                    <span><h5 style="padding: 15px;"><mat-error style=" white-space: normal; "><i class="icon icon-close"></i> {{'LeaderGroupPortal.requiredInfo'| translate}}</mat-error></h5></span>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="form-group">
                                <label class="o-title o-title--label o-title--required js-txt37">{{'LeaderGroupPortal.labelPhone'| translate}}:</label>
                                <input class="o-form__input" type="text" formControlName="emergencyPhone">
                                <div *ngIf="leaderForm.controls['emergencyPhone'].hasError('required') && submited" style="width:100%; background-color: #F2F0E9" align="center">
                                    <span><h5 style="padding: 15px;"><mat-error style=" white-space: normal; "><i class="icon icon-close"></i>{{'LeaderGroupPortal.requiredInfo'| translate}}</mat-error></h5></span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row u-pt20">
                        <div class="col-md-12">
                            <label class="o-title o-title--small o-title--semi u-mb10 js-txt56">{{'LeaderGroupPortal.dataEntry'| translate}}</label>
                            <div class="o-text o-text--description">
                                <div class="js-txt40">{{'LeaderGroupPortal.excelForm'| translate}} </div><br><span class="js-txt41">{{'LeaderGroupPortal.excelMaxPerson'| translate}}: </span><strong class="o-title--orange"> {{Request.numberPeople}}</strong>
                            </div>
                        </div>

                        <div class="col-md-4">
                            <div class="custom-file">
                                <div class="custom-file-text">

                                    <div class="custom-file-text-cont" type="file" *ngIf="fileName=='false'" name="fileUpload">
                                        <i class="icon icon-clip"> </i>
                                        <p>{{'LeaderGroupPortal.attachDocument'| translate}}</p>

                                    </div>
                                    <div class="custom-file-text-cont" type="file" *ngIf="fileName !== 'false'">

                                        <i *ngIf="excelvalid" class="icon icon-check"></i>


                                        <p> {{ fileName }}</p>
                                    </div>
                                    <div *ngIf="!excelvalid" style="width:100%; background-color: #F2F0E9" align="center">
                                        <span><h5 style="padding: 15px;"><mat-error style=" white-space: normal; "><i class="icon icon-close"></i>{{'LeaderGroupPortal.fileNotValid'| translate}}</mat-error></h5></span>
                                    </div>
                                    <div *ngIf="filesize" style="width:100%; background-color: #F2F0E9" align="center">
                                        <span><h5 style="padding: 15px;"><mat-error style=" white-space: normal; "><i class="icon icon-close"></i>{{'LeaderGroupPortal.fileMaxSize'| translate}}</mat-error></h5></span>
                                    </div>
                                    <div *ngIf="fileformat" style="width:100%; background-color: #F2F0E9" align="center">
                                        <span><h5 style="padding: 15px;"><mat-error style=" white-space: normal; "><i class="icon icon-close"></i>{{'LeaderGroupPortal.fileInvalidFormat'| translate}}</mat-error></h5></span>
                                    </div>
                                </div>
                                <div class="custom-file-input">
                                    <input class="custom-file-input attach_document" id="customFile" type="file" data-msg="Volver a subir archivo" accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" (change)="detectFiles($event)">

                                    <span *ngIf="fileName == 'false'">{{'LeaderGroupPortal.uploadFile'| translate}} </span>
                                    <span *ngIf="fileName != 'false'">{{'LeaderGroupPortal.uploadFileAgain'| translate}}</span>
                                </div>
                            </div>


                            <div>
                                <div class="custom-file_extend">

                                    <a style="cursor: pointer;" download="Visitor.xlsx" target="_blank" href="/assets/Visitor.xlsx">

                                        <span>{{ 'LeaderGroupPortal.template' | translate}}</span>
                                    </a>
                                    <i hidden class="icon icon-link"></i>


                                </div>
                            </div>
                        </div>
                        <div class="col-md-12">
                            <div *ngIf="controlMaxPeople" style="width:100%; background-color: #F2F0E9;" align="center">
                                <span><h5 style="padding: 15px;"><mat-error style=" white-space: normal; "><i class="icon icon-close"></i> {{'LeaderGroupPortal.warnExceedsPeople'| translate}} </mat-error></h5></span>
                            </div>
                            <div *ngIf="controlInvalidFormat" style="width:100%; background-color: #F2F0E9;" align="center">
                                <span><h5 style="padding: 15px;"><mat-error style=" white-space: normal; "><i class="icon icon-close"></i> {{'LeaderGroupPortal.invalidFormat'| translate}} </mat-error></h5></span>
                            </div>
                        </div>


                    </div>
                    <div class="row ">
                        <div class="col-md-12 u-pt20">
                            <div class="o-etable">
                                <div class="o-etable__employee">
                                    <div class="row">
                                        <div class="col-md-1 col-xs-2">
                                            <p> <strong class="js-txt44">{{'LeaderGroupPortal.colNumber'| translate}}</strong></p>
                                        </div>
                                        <div class="col-md-1 col-xs-10 col-md-offset-0 col-xs-offset-2">
                                            <p class="u-hide__desktop"> <strong class="js-txt46">{{'LeaderGroupPortal.colType'| translate}}</strong></p>
                                        </div>
                                        <div class="col-md-2 col-xs-10">
                                            <p class="u-show__mobile"> <strong>{{'LeaderGroupPortal.colDetails'| translate}}</strong></p>
                                            <p class="u-hide__desktop"> <strong class="js-txt45">{{'LeaderGroupPortal.colTypeDocument'| translate}}</strong></p>
                                        </div>
                                        <div class="col-md-2 col-xs-10 col-md-offset-0 col-xs-offset-2">
                                            <p class="u-hide__desktop"> <strong class="js-txt46">{{'LeaderGroupPortal.colfullName'| translate}}</strong></p>
                                        </div>
                                        <div class="col-md-1 col-xs-10 col-md-offset-0 col-xs-offset-2">
                                            <p class="u-hide__desktop"> <strong class="js-txt46">{{'LeaderGroupPortal.colGender'| translate}}</strong></p>
                                        </div>
                                        <div class="col-md-2 col-xs-10 col-md-offset-0 col-xs-offset-2">
                                            <p class="u-hide__desktop"> <strong class="js-txt47">{{'LeaderGroupPortal.colPhone'| translate}}</strong></p>
                                        </div>
                                        <div class="col-md-2 col-xs-10 col-md-offset-0 col-xs-offset-2">
                                            <p class="u-hide__desktop"> <strong class="js-txt47">{{'LeaderGroupPortal.colEmail'| translate}}</strong></p>
                                        </div>
                                    </div>
                                </div>

                                <div class="o-etable__employee " *ngIf="peopleIn.length===0 && peopleOut.length===0">
                                    <div class="row">
                                        <div class="col-md-6 col-md-offset-1">
                                            <p>{{'LeaderGroupPortal.dataEntry'| translate}}</p>
                                        </div>
                                    </div>
                                </div>




                                <div class="o-etable--body" *ngIf="peopleIn.length>0 || peopleOut.length>0">
                                    <div class="o-etable__employee " *ngFor="let item of peopleIn; let i = index">
                                        <a class="remove-employee" (click)="deletePerson(i)"></a>
                                        <div class="row">
                                            <div class="col-md-1 col-xs-2">
                                                <p> <span>{{i +1}}</span></p>
                                            </div>
                                            <div class="col-md-1 col-xs-10" col-md-offset-0 col-xs-offset-1>
                                                <p> <span *ngIf="item.passportNumber">{{'LeaderGroupPortal.labelPassport'| translate}}</span><span *ngIf="item.passportNumber && item.nationalId"> / </span> <span *ngIf="item.nationalId">RUT</span> </p>
                                            </div>
                                            <div class="col-md-2 col-xs-10">
                                                <p><span>{{item.documentNumber}}</span></p>
                                            </div>
                                            <div class="col-md-2 col-xs-10 col-md-offset-0 col-xs-offset-2">
                                                <p>{{item.firstName + ' ' | titlecase}}{{item.lastName | titlecase}}</p>
                                            </div>
                                            <div class="col-md-1 col-xs-10 col-md-offset-0 col-xs-offset-2">
                                                <p>{{item.gender | titlecase}}</p>
                                            </div>
                                            <div class="col-md-2 col-xs-10 col-md-offset-0 col-xs-offset-2">
                                                <p>{{item.phoneNumber}}</p>
                                            </div>
                                            <div class="col-md-2 col-xs-10 col-md-offset-0 col-xs-offset-2">
                                                <p title="{{item.email}}" style="width:100%; text-overflow: ellipsis; text-overflow: ellipsis; overflow: hidden;">{{item.email}}</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div *ngIf="peopleOut.length>0">
                                        <div class="o-etable__employee">
                                            <div class="row">
                                                <div class="col-md-12 col-xs-12">
                                                    <h6> <i class="icon icon-close"></i><span class="js-txt52">{{'LeaderGroupPortal.personExistBHP'| translate}}.</span></h6>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="o-etable__employee  o-etable__employee--rejected" *ngFor="let item of peopleOut; let i = index">
                                            <a class="remove-employee" (click)="deletePersonNotValid(i)"></a>
                                            <div class="row">

                                                <div class="col-md-1 col-xs-2">
                                                    <p> <span>{{i +1}}</span></p>
                                                </div>
                                                <div class="col-md-1 col-xs-10" col-md-offset-0 col-xs-offset-1>
                                                    <p> <span *ngIf="item.documentType==='passportnumber'">{{'LeaderGroupPortal.labelPassport'| translate}}</span><span *ngIf="item.documentType==='passportnumber' && item.documentType==='nationarid'"> / </span>                                                        <span *ngIf="item.documentType=='nationalid'">RUT</span> </p>
                                                </div>
                                                <div class="col-md-2 col-xs-10">
                                                    <p><span>{{item.documentNumber}}</span></p>
                                                </div>
                                                <div class="col-md-3 col-xs-10 col-md-offset-0 col-xs-offset-2">
                                                    <p>{{item.firstName + ' ' + item.lastName}}</p>
                                                </div>
                                                <div class="col-md-2 col-xs-10 col-md-offset-0 col-xs-offset-2">
                                                    <p>{{item.phoneNumber}}</p>
                                                </div>
                                                <div class="col-md-2 col-xs-10 col-md-offset-0 col-xs-offset-2">s
                                                    <p title="{{item.email}}" style="width:100%; text-overflow: ellipsis; text-overflow: ellipsis; overflow: hidden;">{{item.email}}</p>
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>






                    <div class="o-etable__group" style="padding-top: 10px;">
                        <div *ngIf="controlNotPeopleValid" style="width:100%; background-color: #F2F0E9" align="center">
                            <span><h5 style="padding: 15px;"><mat-error style=" white-space: normal; "><i class="icon icon-close"></i>{{'LeaderGroupPortal.oneValidPerson'| translate}}</mat-error></h5></span>
                        </div>
                    </div>

                    <div class="row u-pt20">
                        <div class="col-md-12">
                            <h2 class="o-title o-title--medium js-txt37">{{'LeaderGroupPortal.securityCode'| translate}}</h2>
                            <p class="o-text">{{'LeaderGroupPortal.securityCodeSub'| translate}}</p>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-6">
                            <div class="form-group">
                                <input class="o-form__input" type="text" formControlName="verificationCode" id="verificationCode">
                            </div>
                            <div *ngIf="leaderForm.controls['verificationCode'].hasError('required') && submited" style="width:100%; background-color: #F2F0E9" align="center">
                                <span><h5 style="padding: 15px;"><mat-error style=" white-space: normal; "><i class="icon icon-close"></i> {{'LeaderGroupPortal.requiredInfo'| translate}}</mat-error></h5></span>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-12 u-pt50">
                            <div class="o-form__checkbox u-mb20">
                                <input type="checkbox" value="value" formControlName="confirm" name="confirm" required><span></span>
                                <a class="open_modal" (click)="openDialog()" data="terms" style="cursor:pointer">{{'LeaderGroupPortal.confirmTerms'| translate}}.</a>
                                <div *ngIf="leaderForm.controls['confirm'].hasError('required') && submited" style="width:100%; background-color: #F2F0E9" align="center">
                                    <span><h5 style="padding: 15px;"><mat-error style=" white-space: normal; "><i class="icon icon-close"></i> {{'LeaderGroupPortal.requiredInfo'| translate}}</mat-error></h5></span>
                                </div>
                            </div>

                        </div>
                    </div>
                    <br>
                    <div>
                        <button class="btn btn--primary">{{'LeaderGroupPortal.btnGenerate'| translate}}</button>
                    </div>
                </form>
            </div>

        </div>
    </div>
</main>